import { Component } from '@angular/core';

@Component({
    selector: 'app-footer-cmp',
    templateUrl: 'footer.component.html',
    styleUrls: ['./footer.component.scss']
})

export class FooterComponent {
    public currentDate: Date = new Date();
    public versioneBeta: boolean = window.location.href.toString().indexOf("beta") > 0;
}
